import { ArrowBigGreen } from "@components/svgs";
import { BodyNormal } from "@ui/fonts";
import React from "react";
import clsx from "clsx";
import styles from "@scss/components/back-button.module.scss";
import { useNavigate } from "react-router-dom";

export type BackButtonProps = {
  link?: string;
  className?: string;
  children?: string;
  off?: boolean;
};

export const BackButton: React.FC<BackButtonProps> = ({
  link,
  className,
  children,
  off,
}) => {
  const history = useNavigate();

  const handleClick = () => {
    if (off) return;
    if (link) {
      history(link);
    } else {
      history(-1);
    }
  };

  return (
    <button
      className={clsx(styles.backButton, className)}
      onClick={handleClick}
    >
      <ArrowBigGreen />
      <BodyNormal color="green"> {children ? children : "Назад"}</BodyNormal>
    </button>
  );
};
